import { useTranslation } from 'react-i18next';

import { Card, CardContent } from '@/components/ui/card';
import { Skeleton } from '@/components/ui/skeleton';

import CardSkeleton from '../../Components/CardSkeleton';

/**
 * Loading state skeleton for voice integration pages (Twilio, Telnyx, and future providers).
 * Mirrors the structure of Account + Preferences + Transcription + Voice cards + save button.
 */
const VoiceIntegrationSkeleton = () => {
  const { t } = useTranslation();

  return (
    <div className="flex min-h-screen w-full justify-center">
      <div className="flex w-xl flex-col gap-12">
        <Card className="rounded-md border-border py-0 shadow-none">
          <CardContent className="flex items-center gap-4 px-4 pt-4 pb-5">
            <div className="flex flex-1 flex-col gap-1">
              <Skeleton className="h-4 w-32" />
            </div>
            <Skeleton className="h-6 w-10 rounded-full" />
          </CardContent>
        </Card>
        <CardSkeleton title={t('common.account')} rows={4} />
        <CardSkeleton title={t('integrations.voice_common.preferences')} rows={3} />
        <CardSkeleton
          title={t('integrations.voice_common.transcription.speech_to_text')}
          rows={2}
        />
        <CardSkeleton title={t('integrations.voice_common.voice.text_to_speech')} rows={2} />
        <div className="flex justify-start">
          <Skeleton className="h-9 w-28" />
        </div>
      </div>
    </div>
  );
};

export default VoiceIntegrationSkeleton;
